<div class="dashboard-content" style="padding: 120px 40px 50px">
    <section>
        <div class="row">
            <div class="col-xl-6 pe-4">
                <div class="upgrade-card">

                    <span class="back-btn" routerLink="/home/subscription">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 12H20" stroke="#586277" stroke-width="1.53752" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8.99997 17C8.99997 17 4.00002 13.3176 4 12C3.99999 10.6824 9 7 9 7"
                                stroke="#586277" stroke-width="1.53752" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>

                    <div class="upgrade-card-content">
                        <div class="heading">
                            <h1>Upgrade to Plus</h1>
                            <p>
                                Do more with unlimited contests, tasks, <br>
                                awards etc.
                            </p>
                        </div>

                        <form [formGroup]="billingForm" (ngSubmit)="submitForm()" class="upgrade-form row">
                            <div class="col-12">
                                <div class="form-group ">
                                    <label for="email" class="form-label">Billed to</label>
                                    <input type="email" class="form-control" id="email" placeholder="Enter your email"
                                        formControlName="email">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group ">
                                    <label for="email" class="form-label">Payment details</label>
                                    <div class="row">
                                        <div class="col-md-4 ps-0">
                                            <div class="payment-detail credit-card "
                                                [ngClass]="{'active': selectedPayment === 'credit-card'}"
                                                (click)="selectPaymentMethod('credit-card')">
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2 12.3594C2 8.82189 2 7.05314 3.0528 5.87227C3.22119 5.6834 3.40678 5.50873 3.60746 5.35024C4.86213 4.35938 6.74142 4.35938 10.5 4.35938H13.5C17.2586 4.35938 19.1379 4.35938 20.3925 5.35024C20.5932 5.50873 20.7788 5.6834 20.9472 5.87227C22 7.05314 22 8.82189 22 12.3594C22 15.8969 22 17.6656 20.9472 18.8465C20.7788 19.0354 20.5932 19.21 20.3925 19.3685C19.1379 20.3594 17.2586 20.3594 13.5 20.3594H10.5C6.74142 20.3594 4.86213 20.3594 3.60746 19.3685C3.40678 19.21 3.22119 19.0354 3.0528 18.8465C2 17.6656 2 15.8969 2 12.3594Z"
                                                        stroke="#B88917" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10 16.3594H11.5" stroke="#B88917" stroke-width="1.5"
                                                        stroke-miterlimit="10" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M14.5 16.3594H18" stroke="#B88917" stroke-width="1.5"
                                                        stroke-miterlimit="10" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M2 9.35938H22" stroke="#B88917" stroke-width="1.5"
                                                        stroke-linejoin="round" />
                                                </svg>

                                                <span>
                                                    Credit Card
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-4 ps-0 pe-0">
                                            <div class="payment-detail bank-account"
                                                [ngClass]="{'active': selectedPayment === 'bank-account'}"
                                                (click)="selectPaymentMethod('bank-account')">
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2 8.92844C2 7.73226 2.48238 6.9992 3.48063 6.44366L7.58987 4.15682C9.7431 2.95853 10.8197 2.35938 12 2.35938C13.1803 2.35938 14.2569 2.95853 16.4101 4.15682L20.5194 6.44366C21.5176 6.9992 22 7.73227 22 8.92844C22 9.2528 22 9.41499 21.9646 9.54832C21.7785 10.2488 21.1437 10.3594 20.5307 10.3594H3.46928C2.85627 10.3594 2.22152 10.2488 2.03542 9.54832C2 9.41499 2 9.2528 2 8.92844Z"
                                                        stroke="#828999" stroke-width="1.5" />
                                                    <path d="M11.9958 7.35938H12.0048" stroke="#828999" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4 10.3594V18.8594M8 10.3594V18.8594" stroke="#828999"
                                                        stroke-width="1.5" />
                                                    <path d="M16 10.3594V18.8594M20 10.3594V18.8594" stroke="#828999"
                                                        stroke-width="1.5" />
                                                    <path
                                                        d="M19 18.8594H5C3.34315 18.8594 2 20.2025 2 21.8594C2 22.1355 2.22386 22.3594 2.5 22.3594H21.5C21.7761 22.3594 22 22.1355 22 21.8594C22 20.2025 20.6569 18.8594 19 18.8594Z"
                                                        stroke="#828999" stroke-width="1.5" />
                                                </svg>

                                                <span>
                                                    Bank Account
                                                </span>

                                            </div>
                                        </div>
                                        <div class="col-md-4 pe-0">
                                            <div class="payment-detail paypal"
                                                [ngClass]="{'active': selectedPayment === 'paypal'}"
                                                (click)="selectPaymentMethod('paypal')">
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6.29358 5.19437L4.16511 18.0306C3.98586 19.1116 3.89623 19.6521 4.19427 20.0058C4.49231 20.3594 5.03749 20.3594 6.12785 20.3594H6.53027C7.35308 20.3594 7.76448 20.3594 8.04501 20.1149C8.32554 19.8703 8.38372 19.461 8.50008 18.6422L8.96761 15.3528C9.00457 15.0927 9.02305 14.9627 9.05213 14.8514C9.26041 14.0542 9.93391 13.4671 10.7485 13.3726C10.8622 13.3594 10.9929 13.3594 11.2543 13.3594H12.4163C15.5113 13.3594 18.1943 11.2067 18.8803 8.17321C19.5536 5.19513 17.3016 2.35938 14.2631 2.35938H9.62312C8.5093 2.35938 7.95239 2.35938 7.51383 2.59418C7.26304 2.72845 7.04377 2.91515 6.87077 3.14173C6.56824 3.53794 6.47669 4.09008 6.29358 5.19437Z"
                                                        stroke="#828999" stroke-width="1.5" />
                                                    <path
                                                        d="M8.24315 19.8592L8.01451 21.1919C7.90978 21.8023 8.38532 22.3592 9.01128 22.3592H11.0018C11.4961 22.3592 11.9179 22.0058 11.9991 21.5236L12.7285 17.1948C12.8098 16.7127 13.2316 16.3592 13.7258 16.3592H15.5289C18.11 16.3592 20.3448 14.5861 20.9047 12.0939C21.2967 10.3494 20.4437 8.6693 19 7.86035"
                                                        stroke="#828999" stroke-width="1.5" />
                                                </svg>

                                                <span>
                                                    Paypal
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="0000 0000 0000 0000"
                                        maxlength="19" formControlName="card_number" (input)="formatBankNumber($event)">
                                </div>
                            </div>


                            <div class="row ">
                                <div class="col-md-6 ps-0">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="expiry" placeholder="MM/YY"
                                            maxlength="5" formControlName="expiry" (input)="formatExpiry($event)">
                                    </div>
                                </div>
                                <div class="col-md-6 pe-0">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="cvv" placeholder="CVV" maxlength="3"
                                            formControlName="cvv" (input)="formatCvv($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group ">
                                    <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a country"
                                        class="custom-select" formControlName="country" [nzOptionOverflowSize]="5">
                                        <nz-option *ngFor="let country of countryRecords" [nzValue]="country.code"
                                            [nzLabel]="country.name"></nz-option>
                                    </nz-select>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group ">
                                    <input type="text" class="form-control text-center" placeholder="00000"
                                        [maxlength]="6" formControlName="zip_code">
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-5 ps-0">
                                        <button class="btn btn-gray fw-normal w-100">Cancel</button>
                                    </div>
                                    <div class="col-7 pe-0">
                                        <button class="btn btn-primary fw-normal w-100"
                                            [disabled]="billingForm.invalid">Subscribe</button>
                                    </div>
                                </div>
                            </div>

                            <p class="bottom-text">
                                By providing card information, you allow us to charge your card for future payment.
                            </p>

                        </form>

                    </div>

                </div>
            </div>
            <div class="col-xl-6 ps-4">
                <div class="upgrade-type">
                    <h1>
                        Starter Plan
                    </h1>

                    <div class="subscription-type row">
                        <div class="col-12 mb-4 z50">
                            <div class="subscription-type-item" [class.active]="selectedSubscription.mode == 'monthly'"
                                (click)="selectSubscription('monthly')">
                                <div class="circle-checkbox-container white-checkbox">
                                    <input type="radio" id="circle-checkbox1" class="circle-checkbox"
                                        [checked]="selectedSubscription.mode == 'monthly'" />
                                    <label for="circle-checkbox1"></label>
                                </div>
                                <div class="subscription-type-item-content">
                                    <h6>Pay monthly</h6>
                                    <span>$20/ Month/ Member</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 z50">
                            <div class="subscription-type-item justify-content-between"
                                [class.active]="selectedSubscription.mode == 'annually'"
                                (click)="selectSubscription('annually')">
                                <div class="d-flex align-items-center" style="gap: 40px;">
                                    <div class="circle-checkbox-container white-checkbox">
                                        <input type="radio" id="circle-checkbox2" class="circle-checkbox"
                                            [checked]="selectedSubscription.mode == 'annually'" />
                                        <label for="circle-checkbox2"></label>
                                    </div>
                                    <div class="subscription-type-item-content">
                                        <h6>Pay Annually</h6>
                                        <span>$16/ Month/ Member</span>
                                    </div>
                                </div>
                                <span class="discount-text">Save 20%</span>
                            </div>
                        </div>

                        <div class="line-divider z50">
                        </div>

                        <div class="col-12 z50">
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="total-text">
                                    Total
                                </span>
                                <span class="total-price">
                                    {{selectedSubscription.mode === 'annually' ? (selectedSubscription.price -
                                    selectedSubscription.price * 0.2 ) : selectedSubscription.price }}/{{
                                    selectedSubscription?.mode | titlecase }}

                                    <ng-container *ngIf="selectedSubscription?.mode === 'annually'">
                                        <span class="text-muted ms-1 text-decoration-line-through">
                                            {{ selectedSubscription?.original_price }}
                                        </span>
                                    </ng-container>
                                </span>

                            </div>
                        </div>

                        <div class="col-12 z50">
                            <div class="policy-text">

                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.84456 12.5631C2.99448 13.6767 3.91677 14.549 5.03912 14.6006C5.98353 14.644 6.94288 14.6667 7.99935 14.6667C9.05582 14.6667 10.0151 14.644 10.9595 14.6006C12.0819 14.549 13.0042 13.6767 13.1541 12.5631C13.252 11.8365 13.3327 11.0917 13.3327 10.3333C13.3327 9.57493 13.252 8.8302 13.1541 8.10353C13.0042 6.99 12.0819 6.11766 10.9595 6.06606C10.0151 6.02265 9.05582 6 7.99935 6C6.94288 6 5.98353 6.02265 5.03912 6.06606C3.91677 6.11766 2.99448 6.99 2.84456 8.10353C2.74671 8.8302 2.66602 9.57493 2.66602 10.3333C2.66602 11.0917 2.74671 11.8365 2.84456 12.5631Z"
                                        stroke="#828999" />
                                    <path
                                        d="M5 5.99967V4.33301C5 2.67615 6.34315 1.33301 8 1.33301C9.65687 1.33301 11 2.67615 11 4.33301V5.99967"
                                        stroke="#828999" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.99805 10.333H8.0048" stroke="#828999" stroke-width="1.33333"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <p>
                                    Guaranteed to be safe & secure, ensuring that all transactions are protected with
                                    the
                                    highest level of security.
                                </p>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="payment-method-img-container">
                                <img src="./../../../../assets/images/GoldenCircles-SCR-Image-BG.png"
                                    alt="payment-method" class="payment-method-img">
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>
</div>